/* eslint key-spacing:0 no-multi-spaces:0 */
import Mustache from 'mustache';
import tools from './../tools.js';
import analytics from '../analytics';

class CampaignContact
{
  constructor() {
    if(document.getElementById('campaign-contact-form')) {
      this.formElement = document.querySelector('#campaign-contact-form');
      this.loadingElement = this.formElement.querySelector('.loading-overlay');

      this.init();
    }
  }

  init() {
    this.formFields = {
      phone    : this.formElement.querySelector('input[name=phone]'),
      email    : this.formElement.querySelector('input[name=email]'),
      location : this.formElement.querySelector('select[name=location]')
    }

    this.formGroups = {
      phone    : this.formElement.querySelector('.form-group.phone'),
      email    : this.formElement.querySelector('.form-group.email'),
      location : this.formElement.querySelector('.form-group.location')
    }
    // Initialize events
    this._formSubmitEvent();
  }

  /**
   * Show form error messages
   *
   * @returns {boolean}
   * @private
   */
  _checkFieldErrors() {
    let errors = false;

    this.formElement.querySelectorAll('.form-group.errors').forEach((el) => {
      el.classList.remove('errors')
    });

    // Phone number or email must be entered
    if (!this.formFields.phone.value && !this.formFields.email.value) {
      this.formGroups.phone.classList.add('errors');
      this.formGroups.email.classList.add('errors');
      errors = true;
    }

    // Location must be entered
    if (!this.formFields.location.value) {
      this.formGroups.location.classList.add('errors');
      errors = true;
    }

    // Phone field validation
    if (this.formFields.phone.value && !tools.validatePhone(this.formFields.phone.value)) {
      this.formGroups.phone.classList.add('errors');
      errors = true;
    }

    // Email field validation
    if (this.formFields.email.value && !tools.validateEmail(this.formFields.email.value)) {
      this.formGroups.email.classList.add('errors');
      errors = true;
    }


    return errors;
  }

  /**
   * Form submit event. Prevent default and send user to ilmastokummit
   *
   * @returns {undefined}
   * @private
   */
  _formSubmitEvent() {
    this.formElement.addEventListener('submit', submitEvent => {
      submitEvent.preventDefault();

      const errors = this._checkFieldErrors();

      if (!errors) {
        this.loadingElement.classList.add('show');

        fetch('/stage-ajax/campaign-contact/', {
          method: 'post',
          body: new FormData(submitEvent.target)
        }).then( response => response.json() ).then( response => {
          // If campaign name exists in form, push data to dataLayer before anything
          if(response.campaignName && response.conversionId) {
            analytics.pushToDataLayer({
              event : 'Conversion',
              conversion : {
                name : `Kampanjalomake lähetetty - ${response.campaignName}`,
                id   : response.conversionId
              }
            });
          }
          const carDetailsTemplate = document.getElementById('contact-form-sent-template').innerHTML;
          document.getElementById('form-sent-container').innerHTML = Mustache.render(carDetailsTemplate, response);
          this.loadingElement.classList.remove('show');
        });
      }
    });
  }
}
export default CampaignContact;
